import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { notification } from 'antd'
import axios from '@utils/request'
import { ILinkedinEnrichPayload } from '@app-store/slices/reporting/linkedinEnrich'
import { rootActions } from '@app-store/slices'

interface TaskAction extends Action {
    payload: ILinkedinEnrichPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.reporting.linkedinEnrich

function* linkedinEnrichSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.post(`/reporting/linkedin-scrape`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield put(payload?.sagaCB?.onSuccess())
            notification.success({
                message: 'Data has been enriched successfully.'
            })
        } else {
            yield put(payload?.sagaCB?.onError())
            notification.error({
                message: response?.result?.message || 'Something went wrong. Please try again later.'
            })
            yield put(onFailure(''))
            throw new Error('')
        }
    } catch (error) {
        notification.error({
            message: error || 'Something went wrong.'
        })
        if (typeof payload?.sagaCB?.onError === 'function') {
            yield put(payload?.sagaCB?.onError())
        }
        yield put(onFailure(error))
    }
}

function* linkedinEnrichSaga(): any {
    yield takeLatest<TaskAction>(onRequest, linkedinEnrichSagaTask)
}

export default linkedinEnrichSaga
